import { Text, Tooltip, TooltipContent, TooltipTrigger } from '@/ui-kit'
import { Info } from 'lucide-react'
import { useReferralsCounts, useReferralsPoints } from '../api'
import { InviteReferralButton } from './InviteReferralButton'
import { ReferralProgramInfo } from './ReferralProgramInfo'
import { ReferralsList } from './ReferralsList'
import { formatNumber } from '@/utils'

export const Referrals = () => {
  const { data: referralsCounts, isFetched: countsAreFetched } = useReferralsCounts()
  const { data: referralsPoints, isFetched: pointsAreFetched } = useReferralsPoints()

  return (
    <div className="flex flex-1 max-tablet:flex-col">
      <div className="ml-4 flex flex-col pb-10 max-tablet:pb-8 max-tablet:pt-4 max-mobile:ml-0 max-mobile:w-auto max-mobile:pr-0">
        <div className="sticky top-[var(--header-height)] w-[270px] pt-10 max-tablet:w-full max-tablet:pt-0">
          <div className="w-[270px] pr-10 max-tablet:pr-0 max-mobile:w-[unset]">
            <Text type="subtitle-semibold">Referrals</Text>
            <div className="mt-3 flex flex-col gap-4">
              <div className="flex flex-col border-b border-solid border-gray-100 pb-4">
                <Text className="text-gray-90">Referral points</Text>
                <Text type="h2">{pointsAreFetched ? formatNumber(Math.round(referralsPoints?.totalPoints || 0), 0) : '-'}</Text>
              </div>
              <div className="flex flex-col border-b border-solid border-gray-100 pb-4">
                <Text className="text-gray-90">Referrals</Text>
                <Text>{countsAreFetched ? referralsCounts?.activatedCount || 0 : '-'}</Text>
              </div>
              <div className="flex flex-col pb-10">
                <Tooltip>
                  <TooltipTrigger>
                    <Text className="text-gray-90 flex items-center gap-2">
                      Pending referrals <Info size={16} className="mt-1" />
                    </Text>
                  </TooltipTrigger>
                  <TooltipContent>
                    <span>Status updates to Active after 24 hours online</span>
                  </TooltipContent>
                </Tooltip>
                <Text>{countsAreFetched ? referralsCounts?.notActivatedCount || 0 : '-'}</Text>
              </div>
            </div>
          </div>
          <InviteReferralButton />
        </div>
      </div>
      <div className="flex-grow p-5">
        <ReferralProgramInfo />
        <Text type="subtitle-semibold" className="mb-4 mt-10 block">
          Top referrals
        </Text>
        <ReferralsList />
      </div>
    </div>
  )
}
